import { render, staticRenderFns } from "./SaleResumeModal.vue?vue&type=template&id=022ef605&scoped=true"
import script from "./SaleResumeModal.vue?vue&type=script&lang=js"
export * from "./SaleResumeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ef605",
  null
  
)

export default component.exports